import { useEffect } from "react";
import { SetterOrUpdater, useRecoilState } from "recoil";

export default function usePersistState(
  atom,
  sessionKey,
  transformData = (data) => {
    return data;
  }
): [any, SetterOrUpdater<any>] {
  const [atomState, setAtom] = useRecoilState(atom);

  useEffect(() => {
    function loadState() {
      const loadedItem = sessionStorage.getItem(sessionKey);

      if (loadedItem) {
        setAtom(transformData(loadedItem));
      }
    }

    loadState();
  }, []);

  return [atomState, setAtom];
}
